<page-content *ngIf="!!myPackage">

  <div *ngIf="!myPackage.tweebie.disabledWebApp" class="row">
    <div class="column">
      <mat-card appearance="outlined">
        <mat-card-header>
          <h4>{{'packages.images.logo' | translate }}</h4>
          <span class="spacer"></span>
          <button (click)="chooseFromMediaAssets('/tweebie/logo')" class="ibexfusion-raised-button"
                  mat-button>{{'general.select' | translate}}</button>
          <button (click)="myPackage.tweebie.logo = null" *ngIf="!!myPackage.tweebie.logo" class="ibexfusion-raised-button" icon="delete"
                  mat-button>{{'general.remove' | translate}}</button>
          <button (click)="readMe('packages-images-logo', 'packages')" class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0">
            <mat-icon>help</mat-icon>
          </button>
        </mat-card-header>
        <div class="preview-container logo">
          <img *ngIf="myPackage.tweebie.logo" [src]="myPackage.tweebie.logo" class="png-image" width="200">
        </div>
      </mat-card>
    </div>
    <div class="column">
      <mat-card appearance="outlined">
        <mat-card-header>
          <h4>{{'packages.images.favicon' | translate }}</h4>
          <span class="spacer"></span>
          <button (click)="chooseFromMediaAssets('/tweebie/favicon')" class="ibexfusion-raised-button"
                  mat-button>{{'general.select' | translate}}</button>
          <button (click)="myPackage.tweebie.favicon = null" *ngIf="!!myPackage.tweebie.favicon" class="ibexfusion-raised-button"
                  icon="delete" mat-button>{{'general.remove' | translate}}</button>
          <button (click)="readMe('packages-images-favicon', 'packages')" class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0">
            <mat-icon>help</mat-icon>
          </button>
        </mat-card-header>
        <div class="preview-container">
          <img *ngIf="myPackage.tweebie.favicon" [src]="myPackage.tweebie.favicon" class="png-image" width="200">
        </div>
      </mat-card>
    </div>
  </div>

  <ng-container *ngIf="superadmin">

    <div class="spacer"></div>

    <div class="row">
      <div class="column full">
        <mat-card appearance="outlined">
          <mat-card-header>
            <h4>Default Image</h4>
          </mat-card-header>
          <div class="preview-container">
            <img *ngIf="myPackage.tweebie.selectionImage" [src]="myPackage.tweebie.selectionImage" width="200">
            <mat-chip-listbox>
              <mat-chip-option *ngIf="activeSeasonImage===-1" class="live" matTooltip="{{'packages.images.liveTip' | translate}}">Live</mat-chip-option>
            </mat-chip-listbox>
          </div>
          <mat-form-field>
            <input [(ngModel)]="myPackage.tweebie.selectionImage" matInput placeholder="Selection image url (deprecated)">
          </mat-form-field>
        </mat-card>
      </div>
    </div>
  </ng-container>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="!myPackage.tweebie.selectionImages || !myPackage.tweebie.selectionImages.length">
    <mat-card-title>
      {{'packages.images.noImageTitle' | translate}}
      <div (click)="readMe('packages-images-seasonal', 'packages')" class="button-right-container float-right">
        <button class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0"><mat-icon>help</mat-icon></button>
      </div>
    </mat-card-title>
    <mat-card-content>{{'packages.images.noImageText' | translate}}</mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="myPackage.tweebie.selectionImages && myPackage.tweebie.selectionImages.length">

    <div *ngFor="let image of myPackage.tweebie.selectionImages, let i = index" class="col-wrapper">
      <mat-chip-listbox>
        <mat-chip-option *ngIf="activeSeasonImage === i" class="live"
                  matTooltip="{{'packages.images.liveTip' | translate}}">{{'general.publish.online' | translate}}</mat-chip-option>
        <mat-chip-option *ngIf="image.disabled" class="disabled"
                  matTooltip="{{'packages.images.disabledTip' | translate}}">{{'general.publish.disabled' | translate}}</mat-chip-option>
      </mat-chip-listbox>

      <div (click)="readMe('packages-images-seasonal', 'packages')" *ngIf="i===0" class="button-right-container float-right">
        <button class="ibexfusion-icon-button help" mat-icon-button style="opacity: 0"><mat-icon>help</mat-icon></button>
      </div>
      <div class="image-wrapper">
        <div class="button-left-container">
          <button (click)="chooseFromImageAssets('/tweebie/selectionImages/' + i)" class="ibexfusion-raised-button"
                  mat-button>{{'general.select' | translate}}</button>
          <button (click)="removeSelectionImage(i)" class="ibexfusion-raised-button" icon="delete"
                  mat-button>{{'general.remove' | translate}}</button>
        </div>

        <div class="preview-container">
          <img *ngIf="image.url" [src]="image.url" width="200">
        </div>
        <smart-input (onChange)="setActiveSeasonImage()" [(model)]="myPackage" [jsonPointerKey]="'/tweebie/selectionImages/' + i"
                     key="disabled" translationPrefix="packages.installedApps"></smart-input>
      </div>

      <div class="settings-wrapper">
        <!--<smart-input key="format" [jsonPointerKey]="'/tweebie/selectionImages/' + i" [(model)]="myPackage" (onChange)="changeSeasonImagesFormat($event, i)"></smart-input>-->
        <smart-input [(model)]="myPackage" [jsonPointerKey]="'/tweebie/selectionImages/' + i" key="positionH"></smart-input>
        <smart-input [(model)]="myPackage" [jsonPointerKey]="'/tweebie/selectionImages/' + i" key="positionV"></smart-input>
      </div>

      <div class="timing-wrapper">
        <h4>{{'packages.images.interval' | translate}}</h4>
        <smart-input (onChange)="setActiveSeasonImage()" [(model)]="myPackage" [jsonPointerKey]="'/tweebie/selectionImages/' + i"
                     format="dd-mm"
                     key="from" translationPrefix="packages.images"></smart-input>
        <smart-input (onChange)="setActiveSeasonImage()" [(model)]="myPackage" [jsonPointerKey]="'/tweebie/selectionImages/' + i"
                     format="dd-mm"
                     key="to" translationPrefix="packages.images"></smart-input>
        <button (click)="cancelTiming(i)" *ngIf="image.from || image.to" class="ibexfusion-raised-button" color="primary"
                mat-button>{{'general.reset' | translate}}</button>
      </div>
    </div>

  </mat-card>

  <div class="button-right-container">
    <button (click)="addSelectionImage()" class="ibexfusion-raised-button" mat-button>{{'packages.images.add' | translate }}</button>
    <button (click)="savePackage()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate }}</button>
  </div>


</page-content>
